import { Maybe, Undef } from 'types/UtilityTypes';
import captureException from 'utils/captureException';

import { QuotingPortal } from './interface';

export const CarrierDeskSubmitAction = 'carrier-desk-submit-quote';
export class CarrierDesk implements QuotingPortal {
  submitAction = CarrierDeskSubmitAction;
  /**
   * Determines if a quote can be submitted to CarrierDesk based on the current tab and document state.
   * Returns true when on a bid submission page (monitorplacebid.aspx or page with "Place New Bid").
   */
  canSubmit(tab: Undef<chrome.tabs.Tab>, html: string): boolean {
    if (!tab?.url) return false;
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    try {
      const url = new URL(tab.url);
      const isCarrierDesk = url.origin?.includes('carrierdesk.com');

      if (!isCarrierDesk) return false;

      const pathname = url.pathname.toLowerCase();
      if (pathname.includes('monitorplacebid.aspx')) return true;

      const hasPlaceBidButton = Array.from(
        doc.querySelectorAll('input, button')
      ).some((el) => {
        const val = el instanceof HTMLInputElement ? el.value : el.textContent;
        return val?.toLowerCase()?.includes('place new bid');
      });

      return !!hasPlaceBidButton;
    } catch (error: any) {
      captureException(error, {
        context: 'Error checking CarrierDesk canSubmit',
      });
      return false;
    }
  }

  /**
   * Additional info for CarrierDesk.
   */
  additionalInfo(tab: Undef<chrome.tabs.Tab>, _html: string): Maybe<string> {
    if (!tab?.url) return null;
    try {
      const url = new URL(tab.url);
      const pathname = url.pathname.toLowerCase();
      if (
        pathname.includes('loadinfo.aspx') &&
        !pathname.includes('monitorplacebid.aspx')
      ) {
        return 'Click "Bid" on the table page while keeping this tab open so Drumkit can auto-submit the bid form for you.';
      }
      return null;
    } catch (error: any) {
      captureException(error, {
        context: 'Error checking CarrierDesk additional info',
      });
      return null;
    }
  }
}
